function Fatal() {
  throw new Error("Fatal error");

  return <></>
}

export default Fatal;
